






import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '首页',
        }))
      }

      loading = computed(() => false)
    },
)
